document.addEventListener('DOMContentLoaded', function () {
  // Trava: o arquivo é incluído em mais de uma seção na mesma página.
  // Sem isso, todo o código abaixo rodaria em duplicidade (várias buscas
  // de frete/avaliações ao mesmo tempo, com respostas se sobrepondo).
  if (window.__rfRedesignInitDone) { return; }
  window.__rfRedesignInitDone = true;

  // ---- Carrossel de depoimentos ----
var testimonialsTrack = document.querySelector('[data-rf-testimonials-track]');
if (testimonialsTrack) {
  var testimonialCards = testimonialsTrack.querySelectorAll('.rf-testimonial');
  var prevBtn = document.querySelector('[data-rf-testimonials-prev]');
  var nextBtn = document.querySelector('[data-rf-testimonials-next]');

  function rfTestimonialsScrollAmount() {
    var firstCard = testimonialsTrack.querySelector('.rf-testimonial');
    if (!firstCard) { return testimonialsTrack.clientWidth; }
    var style = window.getComputedStyle(testimonialsTrack);
    var gap = parseFloat(style.columnGap || style.gap || '24');
    return firstCard.getBoundingClientRect().width + gap;
  }

  function rfUpdateTestimonialsHeight() {
    if (testimonialCards.length === 0) return;
    var trackRect = testimonialsTrack.getBoundingClientRect();
    var visibleMaxHeight = 0;
    testimonialCards.forEach(function (card) {
      var cardRect = card.getBoundingClientRect();
      var isVisible = cardRect.right > trackRect.left + 1 && cardRect.left < trackRect.right - 1;
      if (isVisible) {
        visibleMaxHeight = Math.max(visibleMaxHeight, card.offsetHeight);
      }
    });
    if (visibleMaxHeight > 0) {
      testimonialsTrack.style.height = visibleMaxHeight + 'px';
    }
  }

  var rfTestimonialsResizeTimer;
  testimonialsTrack.addEventListener('scroll', function () {
    clearTimeout(rfTestimonialsResizeTimer);
    rfTestimonialsResizeTimer = setTimeout(rfUpdateTestimonialsHeight, 80);
  }, { passive: true });

  window.addEventListener('resize', rfUpdateTestimonialsHeight);
  window.addEventListener('load', rfUpdateTestimonialsHeight);
  rfUpdateTestimonialsHeight();

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      testimonialsTrack.scrollBy({ left: -rfTestimonialsScrollAmount(), behavior: 'smooth' });
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      testimonialsTrack.scrollBy({ left: rfTestimonialsScrollAmount(), behavior: 'smooth' });
    });
  }
}

  // Header: sombra ao rolar
  var header = document.querySelector('[data-rf-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Menu mobile
  var burger = document.querySelector('[data-rf-burger]');
  var drawer = document.querySelector('[data-rf-drawer]');
  if (burger && drawer) {
    burger.addEventListener('click', function () {
      drawer.classList.toggle('is-open');
    });
  }

  // Acordeão de submenu no drawer mobile
document.querySelectorAll('[data-rf-mobile-submenu-toggle]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var item = btn.closest('[data-rf-mobile-submenu]');
    var isOpen = item.classList.contains('is-open');

    // fecha os outros abertos (opcional — remove se quiser vários abertos ao mesmo tempo)
    document.querySelectorAll('[data-rf-mobile-submenu].is-open').forEach(function (openItem) {
      if (openItem !== item) openItem.classList.remove('is-open');
    });

    item.classList.toggle('is-open', !isOpen);
  });
});

  // Wishlist (coração) nos cards de produto
  document.querySelectorAll('[data-rf-wish]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var liked = btn.classList.toggle('is-liked');
      var icon = btn.querySelector('svg');
      if (icon) {
        icon.style.fill = liked ? 'var(--rf-crimson)' : 'none';
        icon.style.color = liked ? 'var(--rf-crimson)' : '#bbb';
      }
    });
  });

// Filtro de categorias nos produtos em destaque
var pills = document.querySelectorAll('[data-rf-cat-pill]');
var cards = document.querySelectorAll('[data-rf-product-card]');

function filterByPill(pill) {
  pills.forEach(function (p) { p.classList.remove('is-active'); });
  pill.classList.add('is-active');
  var cat = pill.getAttribute('data-rf-cat-pill');
  cards.forEach(function (card) {
    var show = card.getAttribute('data-rf-product-cat') === cat;
    card.style.display = show ? '' : 'none';
  });
}

pills.forEach(function (pill) {
  pill.addEventListener('click', function () {
    filterByPill(pill);
  });
});

// Aplica o filtro inicial com a primeira categoria (já marcada como is-active no Liquid)
if (pills.length > 0) {
  filterByPill(pills[0]);
}

  // Newsletter (usa o form nativo de cliente do Shopify; aqui só troca a UI)
  var form = document.querySelector('[data-rf-newsletter-form]');
  if (form) {
    form.addEventListener('submit', function () {
      var success = document.querySelector('[data-rf-newsletter-success]');
      var hasError = document.querySelector('[data-rf-newsletter-error]');
      if (!hasError && success) {
        // deixa o submit nativo do Shopify seguir; nada a bloquear aqui
      }
    });
  }

  // ---- Avaliações automáticas do Google (Places API) ----
  var googleBox = document.querySelector('[data-rf-google-reviews]');
  if (googleBox) {
    var apiKey = googleBox.getAttribute('data-google-api-key');
    var placeId = googleBox.getAttribute('data-google-place-id');
    var minRating = parseFloat(googleBox.getAttribute('data-min-rating') || '4');

    function rfStars(rating) {
      var rounded = Math.round(rating);
      return '★★★★★'.slice(0, rounded) + '☆☆☆☆☆'.slice(0, 5 - rounded);
    }

    function rfRenderGoogleReviews(place) {
      googleBox.innerHTML = '';
      var reviews = (place.reviews || []).filter(function (r) {
        return r.rating >= minRating;
      });
      if (reviews.length === 0) {
        googleBox.innerHTML = '<p style="grid-column:1/-1;text-align:center;color:#999;">Nenhuma avaliação encontrada com a nota mínima configurada.</p>';
        return;
      }
      reviews.forEach(function (r) {
        var card = document.createElement('div');
        card.className = 'rf-testimonial';

        var initial = (r.author_name || '?').trim().charAt(0).toUpperCase();
        var avatarHtml = r.profile_photo_url
          ? '<img src="' + r.profile_photo_url + '" alt="" style="width:100%;height:100%;border-radius:999px;object-fit:cover;">'
          : initial;

        card.innerHTML =
          '<div class="rf-testimonial__stars">' + rfStars(r.rating) + '</div>' +
          '<p class="rf-testimonial__text">"' + (r.text || '').replace(/</g, '&lt;') + '"</p>' +
          '<div class="rf-testimonial__footer">' +
            '<div class="rf-testimonial__avatar">' + avatarHtml + '</div>' +
            '<div>' +
              '<div class="rf-testimonial__name">' + r.author_name + '</div>' +
              '<div class="rf-testimonial__city">' + (r.relative_time_description || '') + '</div>' +
            '</div>' +
          '</div>';
        googleBox.appendChild(card);
      });
    }

    function rfFetchGoogleReviews() {
      if (!window.google || !window.google.maps || !window.google.maps.places) {
        googleBox.innerHTML = '<p style="grid-column:1/-1;text-align:center;color:#999;">Não foi possível carregar as avaliações do Google agora.</p>';
        return;
      }
      var service = new google.maps.places.PlacesService(document.createElement('div'));
      service.getDetails(
        { placeId: placeId, fields: ['reviews', 'rating', 'user_ratings_total'] },
        function (place, status) {
          if (status === google.maps.places.PlacesServiceStatus.OK && place) {
            rfRenderGoogleReviews(place);
          } else {
            googleBox.innerHTML = '<p style="grid-column:1/-1;text-align:center;color:#999;">Não foi possível carregar as avaliações do Google agora.</p>';
          }
        }
      );
    }

    if (apiKey && placeId) {
      if (window.google && window.google.maps && window.google.maps.places) {
        rfFetchGoogleReviews();
      } else {
        window.rfGoogleReviewsCallback = rfFetchGoogleReviews;
        var script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(apiKey) + '&libraries=places&callback=rfGoogleReviewsCallback';
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }
    }
  }

  // ---- Calculadora de frete ----
  var overlay = document.querySelector('[data-rf-freight-overlay]');
  if (overlay) {
    var steps = overlay.querySelectorAll('[data-rf-freight-step]');
    var openBtns = document.querySelectorAll('[data-rf-freight-open]');
    var closeBtn = overlay.querySelector('[data-rf-freight-close]');
    var backBtns = overlay.querySelectorAll('[data-rf-freight-back]');
    var consultBtn = overlay.querySelector('[data-rf-freight-consult]');
    var cepInput = overlay.querySelector('[data-rf-freight-cep-input]');
    var errorEl = overlay.querySelector('[data-rf-freight-error]');
    var ratesEl = overlay.querySelector('[data-rf-freight-rates]');
    var dummyVariantId = overlay.getAttribute('data-dummy-variant-id');

    function rfShowStep(name) {
      steps.forEach(function (s) {
        s.hidden = s.getAttribute('data-rf-freight-step') !== name;
      });
    }

    function rfOpenModal() {
      overlay.classList.add('is-open');
      rfShowStep('cep');
      if (errorEl) { errorEl.hidden = true; }
      if (cepInput) { cepInput.value = ''; }
    }
    function rfCloseModal() { overlay.classList.remove('is-open'); }

    openBtns.forEach(function (b) { b.addEventListener('click', rfOpenModal); });
    if (closeBtn) closeBtn.addEventListener('click', rfCloseModal);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) rfCloseModal(); });
    backBtns.forEach(function (b) { b.addEventListener('click', function () { rfShowStep('cep'); }); });

    if (cepInput) {
      cepInput.addEventListener('input', function () {
        var digits = cepInput.value.replace(/\D/g, '').slice(0, 8);
        cepInput.value = digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
      });
    }

    function rfFreightError(msg) {
      rfShowStep('cep');
      if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
    }

    function rfRenderRates(rates) {
      ratesEl.innerHTML = '';
      if (!rates || rates.length === 0) {
        ratesEl.innerHTML = '<p style="color:#999;font-size:14px;">Nenhuma opção de entrega encontrada para esse CEP.</p>';
        return;
      }
      rates.forEach(function (r) {
        var row = document.createElement('div');
        row.className = 'rf-freight-modal__rate';
        var priceValue = parseFloat(r.price);
        var priceFormatted = priceValue.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        row.innerHTML =
          '<div><div class="rf-freight-modal__rate-name">' + r.presentment_name + '</div>' +
          (r.delivery_range && r.delivery_range[1] ? '<div class="rf-freight-modal__rate-time">Chega em até ' + r.delivery_range[1] + '</div>' : '') +
          '</div>' +
          '<div class="rf-freight-modal__rate-price">' + (priceValue === 0 ? 'Grátis' : 'R$ ' + priceFormatted) + '</div>';
        ratesEl.appendChild(row);
      });
    }

    function rfLookupCep(zip) {
      return fetch('https://viacep.com.br/ws/' + zip + '/json/')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.erro) { throw new Error('cep-not-found'); }
          return data;
        });
    }

    function rfBuildAddressQuery(zip, cepData) {
      var params = ['shipping_address[zip]=' + encodeURIComponent(zip)];
      params.push('shipping_address[country]=Brazil');
      if (cepData) {
        if (cepData.localidade) { params.push('shipping_address[city]=' + encodeURIComponent(cepData.localidade)); }
        if (cepData.uf) { params.push('shipping_address[province]=' + encodeURIComponent(cepData.uf)); }
        if (cepData.logradouro) { params.push('shipping_address[address1]=' + encodeURIComponent(cepData.logradouro)); }
        if (cepData.bairro) { params.push('shipping_address[address2]=' + encodeURIComponent(cepData.bairro)); }
      }
      return params.join('&');
    }

    function rfQueryShippingRates(zip, cepData) {
      fetch('/cart/shipping_rates.json?' + rfBuildAddressQuery(zip, cepData))
        .then(function (res) { return res.json(); })
        .then(function (data) {
          rfShowStep('result');
          rfRenderRates(data.shipping_rates);
        })
        .catch(function () {
          rfFreightError('Não foi possível calcular o frete agora. Tente novamente em instantes.');
        });
    }

    function rfGetCartCount() {
      return fetch('/cart.js').then(function (res) { return res.json(); }).then(function (cart) { return cart.item_count; });
    }

    if (consultBtn) {
      consultBtn.addEventListener('click', function () {
        var zip = (cepInput.value || '').replace(/\D/g, '');
        if (zip.length !== 8) {
          rfFreightError('Digite um CEP válido (8 números).');
          return;
        }
        if (errorEl) errorEl.hidden = true;
        rfShowStep('loading');

        rfLookupCep(zip).then(function (cepData) {
          rfGetCartCount().then(function (count) {
            if (count > 0) {
              rfQueryShippingRates(zip, cepData);
              return;
            }
            if (!dummyVariantId) {
              rfFreightError('Configuração pendente: defina o produto usado para calcular o frete nas configurações do cabeçalho.');
              return;
            }
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: dummyVariantId, quantity: 1 }] })
            })
              .then(function (res) {
                if (!res.ok) {
                  return res.json().then(function (errData) {
                    throw new Error(errData.description || errData.message || 'add-failed');
                  });
                }
                return rfQueryShippingRatesAndCleanup(zip, cepData, dummyVariantId);
              })
              .catch(function (err) {
                rfFreightError(err && err.message && err.message !== 'add-failed' ? err.message : 'Não foi possível calcular o frete agora. Tente novamente em instantes.');
              });
          });
        }).catch(function () {
          rfFreightError('CEP não encontrado. Confira e tente novamente.');
        });
      });
    }

    function rfQueryShippingRatesAndCleanup(zip, cepData, variantId) {
      return fetch('/cart/shipping_rates.json?' + rfBuildAddressQuery(zip, cepData))
        .then(function (res) { return res.json(); })
        .then(function (data) {
          rfShowStep('result');
          rfRenderRates(data.shipping_rates);
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 0 })
          });
        });
    }
  }

  // ---- Newsletter via WhatsApp (lista de transmissão) ----
  var waNewsletter = document.querySelector('[data-rf-wa-newsletter]');
  if (waNewsletter) {
    var waNumber = waNewsletter.getAttribute('data-wa-number');
    var nameInput = waNewsletter.querySelector('[data-rf-wa-name]');
    var phoneInput = waNewsletter.querySelector('[data-rf-wa-phone]');
    var submitBtn = waNewsletter.querySelector('[data-rf-wa-submit]');
    var formBox = waNewsletter.querySelector('[data-rf-wa-newsletter-form]');
    var errorBox = waNewsletter.querySelector('[data-rf-wa-error]');
    var successBox = waNewsletter.querySelector('[data-rf-wa-success]');

    if (phoneInput) {
      phoneInput.addEventListener('input', function () {
        phoneInput.value = phoneInput.value.replace(/[^\d\s()+-]/g, '');
      });
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        var name = (nameInput && nameInput.value || '').trim();
        var phoneDigits = (phoneInput.value || '').replace(/\D/g, '');

        if (phoneDigits.length < 10) {
          if (errorBox) { errorBox.textContent = 'Digite um WhatsApp válido, com DDD.'; errorBox.hidden = false; }
          return;
        }
        if (errorBox) { errorBox.hidden = true; }

        var message = 'Olá! Quero entrar na lista de ofertas por WhatsApp e receber os 10% de desconto de boas-vindas.';
        if (name) { message += ' Meu nome: ' + name + '.'; }
        message += ' Meu WhatsApp: ' + phoneDigits;

        var url = 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(message);
        window.open(url, '_blank', 'noopener');

        if (formBox) { formBox.style.display = 'none'; }
        if (successBox) { successBox.hidden = false; }
      });
    }
  }

  // ---- Contagem regressiva da Black Friday ----
  var countdownEl = document.querySelector('[data-rf-bf-countdown]');
  if (countdownEl) {
    var endDate = new Date(countdownEl.getAttribute('data-end'));
    var daysEl = countdownEl.querySelector('[data-rf-bf-days]');
    var hoursEl = countdownEl.querySelector('[data-rf-bf-hours]');
    var minutesEl = countdownEl.querySelector('[data-rf-bf-minutes]');
    var secondsEl = countdownEl.querySelector('[data-rf-bf-seconds]');

    function rfPad(n) { return n < 10 ? '0' + n : '' + n; }

    function rfTickCountdown() {
      var diff = endDate.getTime() - Date.now();
      if (isNaN(endDate.getTime()) || diff <= 0) {
        daysEl.textContent = '00'; hoursEl.textContent = '00'; minutesEl.textContent = '00'; secondsEl.textContent = '00';
        return;
      }
      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;
      daysEl.textContent = rfPad(days);
      hoursEl.textContent = rfPad(hours);
      minutesEl.textContent = rfPad(minutes);
      secondsEl.textContent = rfPad(seconds);
    }

    rfTickCountdown();
    setInterval(rfTickCountdown, 1000);
  }

  // ---- Página de produto ----
  var productForm = document.querySelector('[data-rf-product-form]');
  if (productForm) {
    var mainImg = document.querySelector('[data-rf-product-main-img]');
    var thumbs = document.querySelectorAll('[data-rf-product-thumb]');
    var variantIdInput = document.querySelector('[data-rf-product-variant-id]');
    var priceEl = document.querySelector('[data-rf-product-price]');
    var comparePriceEl = document.querySelector('[data-rf-product-compare-price]');
    var addToCartBtn = document.querySelector('[data-rf-add-to-cart]');
    var addToCartLabel = document.querySelector('[data-rf-add-to-cart-label]');
    var waLink = document.querySelector('[data-rf-product-wa-link]');
    var qtyInput = document.querySelector('[data-rf-qty-input]');
    var qtyMinus = document.querySelector('[data-rf-qty-minus]');
    var qtyPlus = document.querySelector('[data-rf-qty-plus]');
    var optionGroups = document.querySelectorAll('[data-rf-product-option-index]');
    var variantsScript = document.querySelector('[data-rf-product-variants]');
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];

    // Miniaturas
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImg) { mainImg.src = thumb.getAttribute('data-full'); }
      });
    });

    // Quantidade
    if (qtyMinus && qtyPlus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        qtyInput.value = v;
      });
      qtyPlus.addEventListener('click', function () {
        var v = (parseInt(qtyInput.value, 10) || 1) + 1;
        qtyInput.value = v;
      });
    }

    function rfFormatMoney(cents) {
      return 'R$\u00A0' + (cents / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function rfCurrentSelections() {
      var selections = [];
      optionGroups.forEach(function (group) {
        var active = group.querySelector('.is-active');
        selections.push(active ? active.getAttribute('data-rf-product-option-value') : null);
      });
      return selections;
    }

    function rfFindVariant(selections) {
      return variants.filter(function (v) {
        return selections.every(function (val, i) {
          return val === null || v.options[i] === val;
        });
      })[0];
    }

    function rfUpdateAvailability(selections) {
      optionGroups.forEach(function (group, idx) {
        var pills = group.querySelectorAll('[data-rf-product-option-value]');
        pills.forEach(function (pill) {
          var testSelections = selections.slice();
          testSelections[idx] = pill.getAttribute('data-rf-product-option-value');
          var match = rfFindVariant(testSelections);
          pill.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    function rfOnVariantChange() {
      var selections = rfCurrentSelections();
      var variant = rfFindVariant(selections);
      rfUpdateAvailability(selections);

      if (!variant) {
        if (addToCartBtn) { addToCartBtn.disabled = true; }
        if (addToCartLabel) { addToCartLabel.textContent = 'Indisponível'; }
        return;
      }

      if (variantIdInput) { variantIdInput.value = variant.id; }
      if (priceEl) { priceEl.textContent = rfFormatMoney(variant.price); }
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = rfFormatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (variant.featured_image && mainImg) {
        mainImg.src = variant.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '$1');
      }
      if (addToCartBtn) { addToCartBtn.disabled = !variant.available; }
      if (addToCartLabel) { addToCartLabel.textContent = variant.available ? (addToCartLabel.getAttribute('data-available-label') || 'Adicionar ao Carrinho') : 'Esgotado';
      }
      if (waLink) {
        var baseMsg = waLink.getAttribute('data-base-message') || '';
        var waNum = waLink.getAttribute('data-wa-number') || '';
        var variantTitle = variant.title && variant.title !== 'Default Title' ? ' (' + variant.title + ')' : '';
        waLink.href = 'https://wa.me/' + waNum + '?text=' + encodeURIComponent(baseMsg + variantTitle);
      }
    }

    optionGroups.forEach(function (group) {
      var pills = group.querySelectorAll('[data-rf-product-option-value]');
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (pill.classList.contains('is-unavailable')) { return; }
          pills.forEach(function (p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          rfOnVariantChange();
        });
      });
    });

    if (addToCartLabel) { addToCartLabel.setAttribute('data-available-label', addToCartLabel.textContent); }
    if (optionGroups.length > 0) { rfUpdateAvailability(rfCurrentSelections()); }

    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(productForm);
      if (addToCartLabel) { addToCartLabel.textContent = 'Adicionando…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function () {
          if (addToCartLabel) { addToCartLabel.textContent = 'Erro, tente de novo'; }
        });
    });
  }

  // Acordeão de informações do produto
  document.querySelectorAll('[data-rf-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('.rf-accordion-item');
      var panel = item.querySelector('[data-rf-accordion-panel]');
      var isOpen = item.classList.contains('is-open');
      item.classList.toggle('is-open', !isOpen);
      panel.style.maxHeight = isOpen ? null : panel.scrollHeight + 'px';
    });
  });

  // Botão de compartilhar
  var shareBtn = document.querySelector('[data-rf-product-share]');
  if (shareBtn) {
    shareBtn.addEventListener('click', function () {
      var url = shareBtn.getAttribute('data-url');
      var title = shareBtn.getAttribute('data-title');
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          var original = shareBtn.innerHTML;
          shareBtn.innerHTML = 'Link copiado!';
          setTimeout(function () { shareBtn.innerHTML = original; }, 2000);
        });
      }
    });
  }

  // ---- Carrinho ----
  var cartForm = document.querySelector('[data-rf-cart-form]');
  if (cartForm) {
    function rfCartChange(line, quantity) {
      cartForm.style.opacity = '.5';
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function () { window.location.reload(); })
        .catch(function () { cartForm.style.opacity = '1'; });
    }

    cartForm.querySelectorAll('[data-rf-cart-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-rf-cart-line]');
        var input = item.querySelector('[data-rf-cart-qty-input]');
        var newQty = Math.max(0, parseInt(input.value, 10) - 1);
        rfCartChange(item.getAttribute('data-rf-cart-line'), newQty);
      });
    });
    cartForm.querySelectorAll('[data-rf-cart-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-rf-cart-line]');
        var input = item.querySelector('[data-rf-cart-qty-input]');
        var newQty = parseInt(input.value, 10) + 1;
        rfCartChange(item.getAttribute('data-rf-cart-line'), newQty);
      });
    });
    cartForm.querySelectorAll('[data-rf-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        rfCartChange(btn.getAttribute('data-line'), 0);
      });
    });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-rf-add-cart]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    const variantId = btn.dataset.variantId;
    const label = btn.querySelector('[data-rf-add-cart-label]');
    const originalText = label ? label.textContent : '';

    btn.disabled = true;
    if (label) label.textContent = 'Adicionando...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then((res) => {
        if (!res.ok) throw new Error('Falha ao adicionar');
        return res.json();
      })
      .then(() => {
        window.location.href = '/cart';
      })
      .catch(() => {
        if (label) label.textContent = 'Erro, tente novamente';
        btn.disabled = false;
        setTimeout(() => {
          if (label) label.textContent = originalText;
        }, 1800);
      });
  });

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-rf-buy-now]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    const variantId = btn.dataset.variantId;
    const label = btn.querySelector('[data-rf-buy-now-label]');
    const originalText = label ? label.textContent : '';

    btn.disabled = true;
    if (label) label.textContent = 'Aguarde...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then((res) => {
        if (!res.ok) throw new Error('Falha ao adicionar');
        window.location.href = '/checkout';
      })
      .catch(() => {
        if (label) label.textContent = 'Erro, tente novamente';
        btn.disabled = false;
        setTimeout(function () {
          if (label) label.textContent = originalText;
        }, 1800);
      });
  });

  // ---- Popup de boas-vindas (lista VIP) ----
  var popup = document.querySelector('[data-rf-popup]');
  if (popup) {
    var popupStorageKey = 'rfPopupLastShown';
    var delay = parseInt(popup.getAttribute('data-delay'), 10) || 0;
    var frequencyDays = parseInt(popup.getAttribute('data-frequency-days'), 10) || 0;
    var popupWaNumber = popup.getAttribute('data-wa-number');
    var popupCloseBtn = popup.querySelector('[data-rf-popup-close]');
    var popupNameInput = popup.querySelector('[data-rf-popup-name]');
    var popupPhoneInput = popup.querySelector('[data-rf-popup-phone]');
    var popupSubmitBtn = popup.querySelector('[data-rf-popup-submit]');
    var popupFormBox = popup.querySelector('[data-rf-popup-form]');
    var popupErrorBox = popup.querySelector('[data-rf-popup-error]');
    var popupSuccessBox = popup.querySelector('[data-rf-popup-success]');

    function rfPopupShouldShow() {
      if (frequencyDays === 0) { return true; }
      var last = localStorage.getItem(popupStorageKey);
      if (!last) { return true; }
      var elapsedDays = (Date.now() - parseInt(last, 10)) / (1000 * 60 * 60 * 24);
      return elapsedDays >= frequencyDays;
    }

    function rfPopupOpen() {
      popup.classList.add('is-open');
      localStorage.setItem(popupStorageKey, Date.now().toString());
    }
    function rfPopupClose() { popup.classList.remove('is-open'); }

    if (rfPopupShouldShow()) {
      setTimeout(rfPopupOpen, delay);
    }

    if (popupCloseBtn) { popupCloseBtn.addEventListener('click', rfPopupClose); }
    popup.addEventListener('click', function (e) { if (e.target === popup) { rfPopupClose(); } });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) { rfPopupClose(); }
    });

    if (popupPhoneInput) {
      popupPhoneInput.addEventListener('input', function () {
        popupPhoneInput.value = popupPhoneInput.value.replace(/[^\d\s()+-]/g, '');
      });
    }

    if (popupSubmitBtn) {
      popupSubmitBtn.addEventListener('click', function () {
        var name = (popupNameInput && popupNameInput.value || '').trim();
        var phoneDigits = (popupPhoneInput.value || '').replace(/\D/g, '');

        if (phoneDigits.length < 10) {
          if (popupErrorBox) { popupErrorBox.textContent = 'Digite um WhatsApp válido, com DDD.'; popupErrorBox.hidden = false; }
          return;
        }
        if (popupErrorBox) { popupErrorBox.hidden = true; }

        var message = 'Olá! Quero entrar na lista VIP e receber os 10% de desconto de boas-vindas.';
        if (name) { message += ' Meu nome: ' + name + '.'; }
        message += ' Meu WhatsApp: ' + phoneDigits;

        window.open('https://wa.me/' + popupWaNumber + '?text=' + encodeURIComponent(message), '_blank', 'noopener');

        if (popupFormBox) { popupFormBox.style.display = 'none'; }
        if (popupSuccessBox) { popupSuccessBox.hidden = false; }
      });
    }
  }
});
